<template>
    <div>
        
        <b-notification v-if="displayNotification" class="is-bottom" type="is-warning" has-icon :active.sync="isActive" aria-close-label="Close notification">
            
            {{username}} Dirigete a tu casilla de correo y hace click en el link del email que te enviamos para validar tu email.
            <a @click='resendEmail'>Si no recibiste nada hace click aqui para que lo reenviemos.</a>
            <b-loading :loading.sync="loading" :can-cancel="true"></b-loading>
        </b-notification>
    </div>
</template>

<script>
import { postHandler } from '../../../services/http'
export default {
    props:{
        username:{
            type:String,
            default:""
        },
        resendValidation:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            isActive:true,
            loading:false
        }
    },
    computed:{
        displayNotification(){
            var location = window.location.pathname
            return !location.includes("/user/settings/")
        }
    },
    methods:{
        async resendEmail(){
            this.loading = true
            this.response = await postHandler(this.resendValidation, {}, {error:false, success:false})
            this.loading = false
            this.isActive = false
        }
    }
}
</script>

<style lang="scss" scoped>
.is-top-right{
    position: fixed;
    z-index:40;
    right: 10px;
    top: 10px;
    width:600px;
}

@media (max-width: 768px){
    .is-top-right{
        width:100%;
    }
};
</style>